import auth from "../../middleware/auth";

export default [{
    path: "/statistics/genaral-list",
    name: "navmenu.statistic.general_list",
    component: () => import("./../../views/statistics/generalListMIZ.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [{
          title: "Home",
          active: false,
          url: "/"
        },
        {
          title: "Общий список МИЗ и 343",
          i18n: "navmenu.statistic.genaral_list",
          active: true
        }
      ]
    },
    pageTitle: "Общий список МИЗ и 343",
    rule: "editor"
  },
  {
    path: "/statistics/genaral-list-gam",
    name: "navmenu.statistic.genaral_list_gam",
    component: () => import("./../../views/statistics/generalListGAM.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [{
          title: "Home",
          active: false,
          url: "/"
        },
        {
          title: "Общий список ГЭМ",
          i18n: "navmenu.statistic.genaral_list_gam",
          active: true
        }
      ]
    },
    pageTitle: "Общий список ГЭМ",
    rule: "editor"
  },
  {
    path: "/statistics/list-pkm",
    name: "navmenu.statistic.list_pkm",
    component: () => import("./../../views/statistics/listPKM.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [{
          title: "Home",
          active: false,
          url: "/"
        },
        {
          title: "Список ПКМ",
          i18n: "navmenu.statistic.list_pkm",
          active: true
        }
      ]
    },
    pageTitle: "Список ПКМ",
    rule: "editor"
  },
  {
    path: "/statistics/list-miz",
    name: "Список МИЗ",
    component: () => import("./../../views/statistics/listMIZ.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [{
          title: "Home",
          active: false,
          url: "/"
        },
        {
          title: "Список МИЗ",
          i18n: "navmenu.statistic.list_miz",
          active: true
        }
      ]
    },
    pageTitle: "Список МИЗ",
    rule: "editor"
  },
  {
    path: "/statistics/list-report",
    name: "Отчет (Выполнение)",
    component: () => import("./../../views/statistics/listReport.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [{
          title: "Home",
          active: false,
          url: "/"
        },
        {
          title: "Отчет (Выполнение)",
          i18n: "navmenu.statistic.list_report",
          active: true
        }
      ]
    },
    pageTitle: "Отчет (Выполнение)",
    rule: "editor"
  },
  {
    path: "/statistics/object-subject-miz",
    name: "navmenu.statistic.object_subject_miz",
    component: () => import("./../../views/statistics/objectSubjectMIZ.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [{
          title: "Home",
          active: false,
          url: "/"
        },
        {
          title: "Объект-Субъект МИЗ",
          i18n: "navmenu.statistic.object_subject_miz",
          active: true
        }
      ]
    },
    pageTitle: "Объект-Субъект МИЗ",
    rule: "editor"
  },
  {
    path: "/statistics/list",
    name: "navmenu.statistic.online_object_subject_mon",
    component: () => import("./../../views/statistics/monitoringOfObjects/index.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [{
          title: "Home",
          active: false,
          url: "/"
        },
        {
          title: "Онлайн мониторинг объектов",
          i18n: "navmenu.statistic.online_object_subject_mon",
          active: true
        }
      ]
    },
    pageTitle: "Онлайн мониторинг объектов",
    rule: "editor"
  },
  {
    path: "/statistics/list/monitoring-of-objects",
    name: "Online monitoring of objects - Maxam Chirchik",
    component: () => import("./../../views/statistics/monitoringOfObjects/maksam-chirchik/monitoringOfObjects.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [{
          title: "Home",
          active: false,
          url: "/"
        },
        {
          title: "Онлайн мониторинг объектов - Максам Чирчик",
          i18n: "Online monitoring of objects - Maxam Chirchik",
          active: true
        }
      ]
    },
    pageTitle: "Онлайн мониторинг объектов - Максам Чирчик",
    rule: "editor"
  },
];
